export default __webpack_public_path__ + "static/media/blue-later-icon.dd7fa590.svg";